(function($, window, undefined) {
  if (window.mg === undefined)
    window.mg = {};

  if (window.mg.ui === undefined)
    window.mg.ui = {};

  var _ = window.mg;

  _.ui.overlayOpener = null;

  _.ui.overlay = function(options) {
    var props = $.extend(true, {
      inline             : false,
      hideButtonCancel   : false,
      href               : undefined, // If inline, clone the href element. Else, the idea is that we can retrieve the content with a get request, but that is not made yet (considered for the forgot-password feature)
      innerOnClose       : null,
      innerOnOpen        : null,
      instantSpinner     : false,
      onClose            : null,
      onOpen             : null,
      overlay            : undefined, // We expect this to a jQuery object. If this is set, we use that instead of generating the overlay on our own
      title              : '',
      showConfirmOnClose : false,
      confirmTitle       : _.translations.AreYouSure,
      confirmCloseText   : _.translations.AreYouSure,
      confirmBtnYesText  : undefined,
      confirmBtnNoText   : undefined,
      footer             : null
    }, options);

    var disabledElements = [];
    var spinnerModal     = null;
    var confirmModal     = null;

    var spinner = function (str, timeout) {
        if (str === 'show') {
            spinnerModal = _.ui.showPleaseWaitModal();
        } else if (str === 'hide') {
            spinnerModal.close();
        }
    };

    var $overlay = $('<div/>'); // Create an empty node to make use of jQuery's helper functions

    _.ui.overlayOpener = $.extend(true, props, {
      addButton: function(id, text, onClick) {
        $('.overlay-footer-inner', '#' + props.id).append('<button type="button" class="btn btn-outline-white" onclick="' + (onClick || '') + '">' + text + '</button>');
      },

      close: function(confirmed) { // This function is fairly generic for now, and one could argue that it could be placed on a more generic level. It is done this way, though, to mirror the modal implementation
        if (confirmed) {
          if (props.existingOverlay) { // Standalone page, go back one step
            _.gaEvent('Overlay_close', 'Overlay', null);

            var redirectURL = props.defaultOnCloseURL ? props.defaultOnCloseURL : '/';

            if (props.onClosePages && document.referrer) {
                var pages = props.onClosePages.split(';');
                var origin = location.origin;
                var ref = document.referrer;
                var prevPage = ref.substring(ref.indexOf(origin) + origin.length);

                $.each(pages, function (k, v) {
                    var isMatch = false;

                    if (v === '/')
                        isMatch = prevPage === v; // When checking for the root, we need an exact match.
                    else
                        isMatch = prevPage.indexOf(v) > -1;

                    if (isMatch) {
                        redirectURL = v;
                        return false; // Break the v-loop
                    }
                });
            }

            mg.redirect(redirectURL);
          }
          else {
            confirmModal && confirmModal.close();
            var $overlay = $('#' + props.id);

            $('body').attr('data-overlay', 'overlay closing');
            $overlay.attr('data-active', '0');

            setTimeout(function() {
              $('body').removeAttr('data-overlay');
              $(window).off('.ui-overlay');

              $.isFunction(props.onClose) && props.onClose(props);
              $overlay.remove();

              _.ui.overlayOpener = null;

              _.gaEvent('Overlay_close', 'Overlay', null);
            }, 400);
          }

          return;
        }

        if (props.showConfirmOnClose) {
          var that = this;
          confirmModal = _.ui.confirmmodal({ title: props.confirmTitle, html: props.confirmCloseText, btnYesText: props.confirmBtnYesText, btnNoText: props.confirmBtnNoText, btnYesOnClick: function () {
              that.close(true); // Close the overlay
          }});
        } else {
          this.close(true);
        }
      },

      disableInnerContent: function(restore) {
        var setDisabled = function($elem, disabled) {
          $elem.attr('disabled', disabled);
        };

        if (restore === true) {
          $.each(disabledElements, function(k, v) {
            setDisabled($(v), false);
          });

          disabledElements = [];
        } else {
          var elementsSelector = '*'; // We may want to replace this with a proper selector at some point, but for now we want to hit all elements
          $(elementsSelector, '#' + props.id).each(function() {
            var $elem = $(this);

            if (!$elem.attr('disabled')) { // Only do this if the element was not already disabled (otherwise it might be enabled on restore)
              disabledElements.push(this);
              setDisabled($elem, true);
            }
          })
        }
      },

      spinner: spinner,

      setConfirmOnClose: function(val) {
        this.showConfirmOnClose = val !== undefined ? val : true;
      },

      setState: function(val) {
        $('#' + (props.id ? props.id : props.overlay && props.overlay.length ? props.overlay[0].id : '')).attr('data-state', val);
      },

      resetState: function() {
        $('#' + (props.id ? props.id : props.overlay && props.overlay.length ? props.overlay[0].id : '')).attr('data-state', 'default');
      }
    });

    var init = function() {
      props.id = props.overlay.attr('id'); // Pluck out the id from the overlay

      $('body').attr('data-overlay', 'overlay showing');
      $('#' + props.id).attr('data-active', '1');

      setTimeout(function() {
        $('body').attr('data-overlay', 'overlay shown');

        $.isFunction(props.innerOnOpen) && props.innerOnOpen(props);
        $.isFunction(props.onOpen) && props.onOpen(props);
      }, 400);

      _.ui.overlayOpener.target = $('#' + props.id)[0];
    };

    $('body').attr('data-overlay', 'overlay');

    if (props.overlay !== undefined) {
      props.existingOverlay = true;
      init();
      _.gaEvent('Overlay_open', 'Overlay', null);
    } else if (props.inline) {
      $overlay.empty();
      $(props.href).clone().appendTo($overlay); // Append a clone

      init();
      _.gaEvent('Overlay_open', 'Overlay', null);
    } else {
      spinner('show', props.instantSpinner ? 1 : undefined);

      const httpReqDefaults = {
          dataType: 'HTML',
          cache: false
      };
      const {
          httpMethod,
          href,
          reqData,
          httpReqDefaultsOveride
      } = props; 

      const httpReqOptions = {
          url: href,
          ...httpReqDefaults,
          ...httpReqDefaultsOveride 
      }; //httpReqOptions: url and combine httpReqDefaults and httpReqDefaultsOveride

      _.ajax.httpRequest(httpMethod ?? 'GET', httpReqOptions, reqData ?? null, false, false).done(function (data, textStatus, xhr) {
        spinner('hide');
        var responseText = xhr.responseText;

        if (xhr.state() == 'resolved') {
          xhr.done(function(r) {
            responseText = r;
          });

          props.overlay = $(responseText); // Create a jQuery element of the response. TODO - Would $.parseHTML be better?
          $('body').append(props.overlay);

          setTimeout(init, 800); // because of the spinner('hide')
          _.gaEvent('Overlay_open', 'Overlay', null);
        }
      });
    }

    return _.ui.overlayOpener;
  };

  $(window.document).on('keydown.overlay', 'main :tabbable', function(e) {
    if (_.ui.overlayOpener && e.keyCode === 9) {
      e.preventDefault();
      $('.overlay-body :focusable:first', '#' + _.ui.overlayOpener.id).focus();
    }
  });
})(jQuery, window);
